module.exports = __webpack_public_path__ + "static/media/think3.e511e173.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/think3.png
// module id = 329
// module chunks = 0